import arrayMove from 'array-move';
import moment from 'moment';
import { DetailKey, Investment, Investor } from 'procura-shared';

// export const avatarImg = (
//   name: string = 'name',
//   shape: 'squares' | 'isogrids' | 'spaceinvaders' | 'labs/isogrids/hexa' | 'label/isogrids/hexa16' = 'squares',
//   theme:
//     | 'frogideas'
//     | 'sugarsweets'
//     | 'heatwave'
//     | 'daisygarden'
//     | 'seascape'
//     | 'summerwarmth'
//     | 'bythepool'
//     | 'duskfalling'
//     | 'berrypie'
//     | 'base' = 'seascape',
//   colors: 2 | 3 | 4 = 4
// ) => {
//   name = name.replaceAll('/', '');
//   return `https://www.tinygraphs.com/${shape}/${name}?theme=${theme}&numcolors=${colors}&size=220&fmt=svg`;
// };

export const investorErrors = (investor: Investor, t: any): string[] => {
  let errors = [];
  const keys = ['address', 'displayEmail', 'email', 'investments', 'name', 'phoneNumber', 'postalCode'];
  keys.forEach((key) => {
    if (investor[key] == null || investor[key].length === 0) {
      errors.push(`No ${t[key]}`);
    }
  });
  return errors;
};

export const investmentsErrors = (investment: Investment, t): string[] => {
  let errors = [];
  const keys = [
    'address',
    'businessType',
    'createdTime',
    'firstPriorityBank',
    'secondPriorityBank',
    'imageURL',
    'lat',
    'lng',
    'leaseEnd',
    'leaseStart',
    'name',
    'nextRentReview',
    'rentReview',
    'investors',
  ];
  keys.forEach((key) => {
    if (investment[key] == null || investment[key].length === 0) {
      errors.push(`No ${t[key]}`);
    }
  });
  return errors;
};

export const sortKeys = (keys: DetailKey[]): DetailKey[] => {
  // keys = reorderKeys(keys, 'postalCode', 'address');
  // keys = reorderKeys(keys, 'tenant', 'secondPriorityBank');
  return keys;
};

export const reorderKeys = (keys: DetailKey[], keyAfter: DetailKey, key: DetailKey): DetailKey[] => {
  const indexAfter = keys.indexOf(keyAfter);
  const index = keys.indexOf(key);
  if (indexAfter >= 0 && index >= 0 && !(indexAfter === index + 1)) {
    arrayMove.mutate(keys, indexAfter, index);
  }
  return keys;
};

// address postal code
// secondPrio tenant

export const getDateString = (timestamp: string | number): string => {
  if (typeof timestamp === 'string') {
    return timestamp;
  }
  const date = new Date(timestamp);
  // eslint-disable-next-line no-self-compare
  return date.getTime() === date.getTime() ? date.toLocaleDateString() : '-';
};

export const getDateFromString = (date: string): Date => {
  let mDate = moment(date, 'DD-MM-YYYY');
  if (!mDate.isValid()) mDate = moment(date, 'DD/MM/YYYY');
  if (!mDate.isValid()) mDate = moment(date, 'MM/DD/YYYY');
  if (!mDate.isValid()) mDate = moment().local();
  return mDate.toDate();
};

export const setDelayed = (newData, setHook, setLoadingHook) => {
  setHook(newData);
  setLoadingHook(true);
  setTimeout(() => {
    setLoadingHook(false);
  }, Math.floor(Math.random() * 1000 + 500));
};

export const round = (value: number | string, decimals: number): number => {
  const pow = Math.pow(10, decimals);
  return Math.round((Number(value) + Number.EPSILON) * pow) / pow;
};

export const format = (value: number | string): string => new Intl.NumberFormat('de-DE').format(Number(value));
